import { UserOutlined } from "@ant-design/icons";
import { Collapse } from "common/components/collapse/collapse";
import { Flex } from "common/components/flex/flex";
import { toShortUSFormat } from "utilities/dateUtility";
import K from "utilities/constants";
import { CandidateLinkItem } from "features/dashboard/components/candidateLinkItem/candidateLinkItem";

const PanelHeader = ({ jobTitle, jobLocation, atsId = null }) => (
  <div>
    <div>
      <span className="font-weight-heavy">{jobTitle}</span> - {jobLocation}
    </div>
    <div>
      <span>ATS ID: {atsId ?? K.NullPlaceholder}</span>
    </div>
  </div>
);

export const JobCandidatePanel = ({ job, candidates }) => {
  const jobTitle = job.title;
  const locationName = job.jobLocation.name;
  const atsId = job.extAtsId;

  return (
    <Collapse compact>
      <Collapse.Panel
        key={job.id}
        header={
          <PanelHeader
            jobTitle={jobTitle}
            jobLocation={locationName}
            atsId={atsId}
          />
        }
        extra={
          <Flex align="center">
            <UserOutlined />
            <span>{candidates.length}</span>
          </Flex>
        }
      >
        <Flex direction="column" gap={8}>
          {candidates.map(({ id, candidate, activity }) => {
            const dateField = K.Candidate.DateFields[activity.dateField];

            return (
              <CandidateLinkItem
                key={id}
                candidateId={candidate.id}
                jobEntryId={id}
                name={candidate.fullName}
              >
                <span className="text-secondary">{candidate.email}</span>
                {dateField && (
                  <span>
                    {dateField.label}: {toShortUSFormat(activity.date)}
                  </span>
                )}
              </CandidateLinkItem>
            );
          })}
        </Flex>
      </Collapse.Panel>
    </Collapse>
  );
};
